import { render, staticRenderFns } from "./IndividualCourseLearnStudentPanel.vue?vue&type=template&id=3c57b185&scoped=true"
import script from "./IndividualCourseLearnStudentPanel.vue?vue&type=script&lang=js"
export * from "./IndividualCourseLearnStudentPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c57b185",
  null
  
)

export default component.exports